import React, { useEffect, useRef, useState } from "react";
import { projects } from "./data-p";
import { motion } from "framer-motion";

const AllProjects = () => {
  const [type, setType] = useState(0);
  const [input, setInput] = useState("");
  const [newProjects, setProjects] = useState(projects);
  const [notFound, setNotFound] = useState(false);

  const childCount = useRef(null);
  useEffect(() => {
    childCount.current.childElementCount <= 0
      ? setNotFound(true)
      : setNotFound(false);
  }, [input, newProjects]);

  useEffect(() => {
    const mapped = projects.filter((item) => {
      if (type === item.sort) {
        return item;
      }
      if (type === 0) {
        return projects;
      }
    });
    setProjects(mapped);
  }, [type]);

  return (
    <div className="all-projects">
      <div className="l-hr all-p">
        <h1>More Projects</h1>
        <div className="p-search">
          <input
            type="text"
            placeholder="Search for projects ..."
            onChange={(e) => setInput(e.target.value)}
          />
          <select onChange={(e) => setType(e.target.options.selectedIndex)}>
            <option name="all">All</option>
            <option name="website">Website & prortfolios ...</option>
            <option name="game">Games</option>
            <option name="web apps">Web apps</option>
          </select>
        </div>
      </div>
      <div className="all-p-box" ref={childCount}>
        {notFound ? (
          <h2 className="not-found">No match found ¯\_(ツ)_/¯</h2>
        ) : (
          newProjects.map((item) => {
            const { id, name, url, img, tech } = item;
            if (name.toLowerCase().includes(input.toLowerCase())) {
              return (
                <motion.a
                  href={url}
                  key={id}
                  className="p-box l-pr"
                  style={{ background: `url(images-p/${img})` }}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1, duration: 0.3 }}
                >
                  <div className="l-pr-txt  o-ps">
                    <h3>{name}</h3>
                    <div className="tech">
                      {tech.map((t, index) => (
                        <code key={index} className={t}>
                          {t}
                        </code>
                      ))}
                    </div>
                  </div>
                </motion.a>
              );
            }
            // else {
            //
            // }
          })
        )}
      </div>
    </div>
  );
};

export default AllProjects;
